import {
  deleteWebFcmToken as deleteWebFcmTokenFromFirebase,
  getWebFcmToken as getWebFcmTokenFromFirebase,
  subscribeToForegroundMessages as subscribeToForegroundMessagesFromFirebase,
} from "../firebase";

export const getWebFcmToken = async (
  options?: { forceRefresh?: boolean }
): Promise<string | null> =>
  (await getWebFcmTokenFromFirebase(options)) as string | null;

export const subscribeToForegroundMessages = async (
  callback: (payload: any) => void
): Promise<() => void> =>
  (await subscribeToForegroundMessagesFromFirebase(callback)) as () => void;

export const deleteWebFcmToken = async (): Promise<boolean> =>
  (await deleteWebFcmTokenFromFirebase()) as boolean;
